import { NgModule } from '@angular/core';
import { ActionReducer, StoreModule } from '@ngrx/store';
import { reducer } from './locations-reducer';
import { initialLocationsState } from './locations-state';
import { StateSlice } from '../state-slice';
import { combineReducers, entityMetaReducer } from '@core/utils/state';
import { EffectsModule } from '@ngrx/effects';
import { LocationEffects } from './locations-effects';
import { metaReducers } from '../app/app-meta-reducer';
import { LocationsDataService } from '@core/data/api/location/locations-data.service';

@NgModule({
    imports: [
      StoreModule.forFeature(StateSlice.LOCATION, (reducer as ActionReducer<any, any>), {
        initialState: initialLocationsState,
        metaReducers: [entityMetaReducer],
        reducerFactory: combineReducers
      }),
      EffectsModule.forFeature([ LocationEffects ])
    ],
    declarations: [],
    providers: [
        LocationsDataService
    ]
  })
  export class LocationStateModule {}